export default __webpack_public_path__ + "static/fertilespringhome1-70cc307ec8c20ef2b123176dce5294b7.png";